import { Stack } from "@mui/material";
import type { FC, PropsWithChildren } from "react";
import { useState } from "react";
import dayjs, { DATE_FORMAT, ISO_DATE_FORMAT } from "../../dayjs";
import ConfirmationDialog from "../confirmationDialog/ConfirmationDialog";
import type { NoteTS } from "../noteStampedList/NoteStampedList";
import { NoteStampedList } from "../noteStampedList/NoteStampedList";

export interface Note {
  text: string;
  date: string; // YYYY-MM-DD
  author: string;
}

interface Props {
  readonly notes: Note[];
  readonly onDeleteNote?: (idx: number) => void | Promise<void>;
}

const Notes: FC<PropsWithChildren<Props>> = ({ notes, children, onDeleteNote }) => {
  const [confirmationDialog, setConfirmationDialog] = useState<{
    content: string;
    onConfirm: () => Promise<void>;
  }>();

  const handleRemoveNote = async (idx: number, note: NoteTS) => {
    setConfirmationDialog({
      content: `Usunąć wpis '${note.text}' z ${note.date.format(DATE_FORMAT)}?`,
      onConfirm: async () => {
        await onDeleteNote?.(idx);
        setConfirmationDialog(undefined);
      },
    });
  };

  return (
    <Stack
      sx={{
        marginTop: "16px",
      }}
    >
      {children}
      <NoteStampedList
        showCopy
        values={notes.map((n) => ({ ...n, date: dayjs(n.date, ISO_DATE_FORMAT) }))}
        onRemove={onDeleteNote ? handleRemoveNote : undefined}
      />
      <ConfirmationDialog
        open={!!confirmationDialog}
        title="Usuń notatkę"
        content={confirmationDialog?.content}
        onCancel={() => setConfirmationDialog(undefined)}
        onConfirm={confirmationDialog?.onConfirm ?? (() => Promise.resolve())}
      />
    </Stack>
  );
};

export default Notes;
